module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0007#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0009#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0010#ch01"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1")]), _vm._v("\tThe Road to Fallujah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0011#ch02"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EOPLE'S")]), _vm._v(" S"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TORIES,")]), _vm._v(" P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ART")]), _vm._v(" I "), _c('i', [_vm._v("collected by Asmaa Khalaf Madlool")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0012#ch03"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2")]), _vm._v("\tConflicting Narratives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0013#ch04"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EOPLE'S")]), _vm._v(" S"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TORIES,")]), _vm._v(" P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ART")]), _vm._v(" II "), _c('i', [_vm._v("collected by Asmaa Khalaf Madlool")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0014#ch05"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3")]), _vm._v(" \tThe First Siege of Fallujah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0015#pt01"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMI,")]), _vm._v(" P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ART")]), _vm._v(" I "), _c('i', [_vm._v("by Kali Rubaii")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0016#ch06"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4")]), _vm._v("\tThe Intersiege Information Campaign")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0017#ch07"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EOPLE'S")]), _vm._v(" S"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TORIES,")]), _vm._v(" P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ART")]), _vm._v(" III "), _c('i', [_vm._v("collected by Asmaa Khalaf Madlool ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0018#ch08"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5")]), _vm._v("\tThe Second Siege of Fallujah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0019#ch09"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AR")]), _vm._v(" H"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EROES")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" W"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AR")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RIMINALS")]), _vm._v(" "), _c('i', [_vm._v("by Ross Caputi")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0020#ch10"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6")]), _vm._v("\tAftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0021#ch11"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HILDREN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" F"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ALLUJAH")]), _vm._v(" "), _c('i', [_vm._v("by Donna Mulhearn")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0022#ch12"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("7")]), _vm._v("\t The Third Siege of Fallujah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0023#pt02"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMI,")]), _vm._v(" P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ART")]), _vm._v(" II "), _c('i', [_vm._v("by Kali Rubaii")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0024#conc"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0025#aft"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FTERWORD")]), _vm._v("\tFallujah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("My Lost Country by Feurat Alani")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("translated by Siobhan Marie Meï")]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0026#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0027#index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/umaCAPUTI0029#gallery"
    }
  }, [_vm._v("Gallery")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695916d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma-CAPUTI-0006.vue
// module id = 72
// module chunks = 0